// import ES from './es';
import EN from './en';
import ES from './es';

const users = {
    EN,
    ES
};

export default users;
